import { SignupForm } from "@/components/signup-form"
import { ConbersaLogo } from "@/components/ConbersaLogo"
import { PageTransition, StaggerChildren, MotionDiv, fadeInLeft, fadeInRight, bounceIn } from "@/components/ui/motion-components"

export default function SignupPage() {
	return (
		<PageTransition>
			<div className="grid min-h-svh lg:grid-cols-2">
				<StaggerChildren className="flex flex-col gap-4 p-6 md:p-10">
					<MotionDiv
						variants={fadeInLeft}
						className="flex justify-center gap-2 md:justify-start"
					>
						<a href="#" className="flex items-center gap-2 font-medium group">
							<MotionDiv
								variants={bounceIn}
								whileHover={{
									rotate: [0, -10, 10, -10, 0],
									scale: 1.1
								}}
								transition={{
									rotate: { duration: 0.5 },
									scale: { type: "spring", stiffness: 300 }
								}}
								className="flex items-center justify-center"
							>
								<ConbersaLogo size={24} className="drop-shadow-sm" />
							</MotionDiv>
							<MotionDiv
								whileHover={{ x: 5 }}
								transition={{ type: "spring", stiffness: 300 }}
							>
								Conbersa
							</MotionDiv>
						</a>
					</MotionDiv>
					<MotionDiv
						variants={fadeInLeft}
						className="flex flex-1 items-center justify-center"
					>
						<MotionDiv
							className="w-full max-w-xs"
							whileHover={{ scale: 1.02 }}
							transition={{ type: "spring", stiffness: 300 }}
						>
							<SignupForm />
						</MotionDiv>
					</MotionDiv>
				</StaggerChildren>
				<MotionDiv
					variants={fadeInRight}
					initial="initial"
					animate="animate"
					className="bg-muted relative hidden lg:block overflow-hidden"
				>
					{/* Animated background with different pattern for signup */}
					<MotionDiv
						animate={{
							background: [
								"linear-gradient(135deg, hsl(var(--primary)/0.08), hsl(var(--accent)/0.08))",
								"linear-gradient(135deg, hsl(var(--accent)/0.08), hsl(var(--secondary)/0.08))",
								"linear-gradient(135deg, hsl(var(--secondary)/0.08), hsl(var(--primary)/0.08))"
							]
						}}
						transition={{
							duration: 10,
							repeat: Infinity,
							ease: "linear"
						}}
						className="absolute inset-0"
					/>
					{/* Different floating pattern for signup */}
					{[...Array(8)].map((_, i) => (
						<MotionDiv
							key={i}
							className="absolute w-1 h-1 bg-accent/30 rounded-full"
							animate={{
								x: [0, -50, 50, 0],
								y: [0, 50, -50, 0],
								opacity: [0, 0.8, 0.8, 0],
								scale: [0.5, 1.2, 0.8, 0.5]
							}}
							transition={{
								duration: 6 + i * 0.5,
								repeat: Infinity,
								delay: i * 0.3,
								ease: "easeInOut"
							}}
							style={{
								left: `${15 + i * 12}%`,
								top: `${25 + i * 8}%`
							}}
						/>
					))}
				</MotionDiv>
			</div>
		</PageTransition>
	)
} 